/**
 * Portal ICAVI - Serviço de domínio: Cidades
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 * Importar `api` de apiClient para reutilizar a instância configurada com auth.
 */
import axios from 'axios';
import { api } from '../apiClient';
export const cidadesServiceMethods = {
    /**
     * Busca municípios brasileiros por UF (proxy IBGE via backend).
     */
    async getMunicipiosPorEstado(uf) {
        const normalizedUf = String(uf ?? '').trim().toUpperCase();
        if (!normalizedUf)
            return [];
        try {
            const response = await api.get(`/api/cidades/estado/${encodeURIComponent(normalizedUf)}/municipios`);
            return Array.isArray(response.data) ? response.data : [];
        }
        catch (error) {
            console.error(`Erro ao buscar municípios da UF ${normalizedUf}:`, error);
            throw error;
        }
    },
    /**
     * Busca lista de cidades
     */
    async getCidades() {
        try {
            const response = await api.get('/api/cidades');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar cidades:', error);
            throw error;
        }
    },
    /**
     * Busca lista de cidades com dados completos
     */
    async getCidadesCompletas() {
        try {
            const response = await api.get('/api/cidades-completas');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar cidades completas:', error);
            throw error;
        }
    },
    /**
     * Adiciona uma nova cidade
     */
    async addCidade(cidade) {
        try {
            const response = await api.post('/api/cidade', cidade);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao adicionar cidade:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Atualiza uma cidade existente
     */
    async updateCidade(cidadeId, cidade) {
        try {
            const response = await api.put(`/api/cidade/${cidadeId}`, cidade);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar cidade:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
    /**
     * Exclui uma cidade
     */
    async deleteCidade(cidadeId) {
        try {
            const response = await api.delete(`/api/cidade/${cidadeId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir cidade:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
